export const PAYMENT_INFORMATION_DESCRIPTION = Object.freeze({
    ACCOUNT_NAME: 'Account Holder',
    ACCOUNT_NUMBER: 'Account or Invoice Number',
    MEMO: 'Memo',
    ATTACHMENTS: 'Attachments',
})